import z from 'zod';
import StocktakeTargetType from '../enums/StocktakeTargetType';

export const StocktakeTargetSchema = z.object({
    targetId: z.string(),
    targetType: z.nativeEnum(StocktakeTargetType),
});

export type StocktakeTarget = z.infer<typeof StocktakeTargetSchema>;
